import List from "@/components/list";

import { baseInfoColumns, userAddColumns, otherColumns, userMissingeColumns } from "./constants"

const Table = (args) => {
  const { listeners, props } = args;
  const RCSelectionChange = listeners["selection-change"] || function() {};
  const updateStatus = listeners["updateStatus"] || function() {};
  const linkStatus = listeners["linkStatus"] || function() {};

  const activeTab = props.activeTab;
  
  const Deal = ({ props: { vo } }) => {
    const item = vo.row;
    let dealConf = [];
    if (activeTab === '1') {
      let flag = item.isUpdate == 1 && props.isLast;
      const classStr = flag ? "iconfont icgengxin iconfont-adapt" : "iconfont icgengxin iconfont-adapt-disabled";
      const func = flag ? () => updateStatus(item) : () => {};
      dealConf = [[classStr, "更新", func, "userCheck:updateBasic"]]
    } else if (activeTab === '2') {
      let flag = item.linkStatusName === '未关联' && props.isLast;      
      const classStr = flag ? "iconfont icguanlianyonghu iconfont-adapt" : "iconfont icguanlianyonghu iconfont-adapt-disabled";
      const func = flag ? () => linkStatus(item) : () => {};
      dealConf = [[classStr, "关联用户", func, "userCheck:link"]]
    }
    return (
      <div class="deal-group">
        {dealConf.map((item) => {
          return (
            <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
              <i class={item[0]} onClick={item[2]}></i>
            </el-tooltip>
          )
        })}
      </div>
    );
  };


  function selectable(row) {
    return row.isUpdate == 1;
  }

  // 根据类型切换不同 Columns
  let AccountTableConfig = [];
  switch (activeTab) {
    case '1': AccountTableConfig = [ 
      { type: "selection", width: "40", label: 'main', selectable: selectable }, 
      ...baseInfoColumns, 
      { label: "操作", width: "40", render: vo => <Deal vo={vo} /> }
    ]; break;
    case '2': AccountTableConfig = [ ...userAddColumns, { label: "操作", width: "40", render: vo => <Deal vo={vo} /> }]; break;
    case '3': AccountTableConfig = [...otherColumns]; break;
    case '4': AccountTableConfig = [...userMissingeColumns]; break;
  }

  return <List {...args} onSelectionChange={RCSelectionChange} talbeCols={AccountTableConfig}/>;
};

export default Table;
